module.exports = __webpack_public_path__ + "img/3-2.0a53a4b2.svg";